import React, { useState } from 'react';
import { useMemo } from 'react';
import { css } from 'aphrodite';
import PlansGrid from '../../../common/subscription-card/PlansGrid';
import { translate } from '../../../helper';
import { WORK_FLOW_COMMON_SCREENS, subscriptionType } from '../const';
import { useScreenSubscription } from '../screenProviderLocationAccount';
import { styles } from '../styles';
import { mapPlans } from '../../../common/utils/mapPlans';

export const MasterAccountSubscription = () => {
    const [isYearly, setIsYearly] = useState(false);
    const { subscriptionProduct, setSelectedSubscription, navigateTo } = useScreenSubscription();
    const plans = useMemo(() => mapPlans(subscriptionProduct, undefined, undefined, true), [subscriptionProduct]);
    if (!plans) {
        return <p>{translate('noSubscriptionData')}</p>;
    }
    const visiblePlans = isYearly ? plans.filter(p => (p.key || '').toLowerCase() !== 'free trial') : plans;
    
    const handlePurchaseFromGrid = (pickedPlan) => {
        const group = subscriptionProduct[pickedPlan.key];
        const backendItem = pickedPlan.isYearly ? group.yearly : group.monthly;
        setSelectedSubscription({
            title: pickedPlan.title,
            subTitle: pickedPlan?.isYearly ? 'yearlySubscription' : 'monthlySubscription',
            paymentId: backendItem?.id,
            price: backendItem?.price || subscriptionType.DEFAULT_VALUE,
            recurringInterval: backendItem?.recurring_interval || subscriptionType.DEFAULT_VALUE,
            percentageDiscount: backendItem?.discount || subscriptionType.DEFAULT_VALUE
        });
        navigateTo(WORK_FLOW_COMMON_SCREENS.PAYMENT_INFO)
    }

    return ( 
        <div className={css(styles.subscriptionContainer)}>
            <PlansGrid
                plans={visiblePlans}
                isYearly={isYearly}
                initialIsYearly={isYearly}
                onIsYearlyChange={setIsYearly}
                onButton2Click={handlePurchaseFromGrid}
            />
        </div>
    );
};
